import React from "react";
import styled from "styled-components";

import { breakpoints, colors } from "@trailhead/asurion-ui";
import { FlexColumnContainer } from "@trailhead/core-ui";

import { CTASlider, IntroHeader } from "../components";

const DefaultSmartSetupContainer = styled(FlexColumnContainer)`
  color: ${colors.black};
  align-items: flex-start;
  margin: 0 auto;
  max-width: 50rem;
  ${breakpoints.md} {
    flex-direction: row;
    justify-content: flex-start;
    align-content: flex-start;
    text-align: left;
  }
`;

export const DefaultSmartSetup: React.FC = () => (
  <DefaultSmartSetupContainer>
    <IntroHeader />
    <CTASlider />
  </DefaultSmartSetupContainer>
);
